import { useSignalRMessage } from "../../application/signalr";
import { useAppDispatch, useAppSelector } from "../../framework/redux/hooks";
import { addAlert, removeAlert } from "../../framework/redux/slices/appSlice";
import { AlertSeverity } from "../../models/common/enums";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { TransportOrderNotificationMessage } from "../../models/common/hubmessage";
import { transportOrderStateNames } from "../../models/transport/transportOrder";

export const useListenTransportOrderNotifications = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const vehicles = useAppSelector((state) => state.vehicle.idTitles);

    useSignalRMessage("TransportOrderNotification", (notification: TransportOrderNotificationMessage) => {
        const { transportOrderId, orderNumber, message, state, vehicleId } = notification;

        const orderStateName = t(transportOrderStateNames[state]);
        const vehicleDetails = vehicles?.find(vehicle => vehicle.id === vehicleId) || null;

        const handleClick = () => {
            dispatch(removeAlert());
            navigate(`/transport/order/${transportOrderId}`);
        };

        dispatch(
            addAlert({
                message: t(message, {
                    orderNro: orderNumber,
                    state: orderStateName,
                    vehicleName: vehicleDetails ? vehicleDetails.title : t("common.unknown"),
                }),
                severity: AlertSeverity.Info,
                duration: 5000,
                onClick: handleClick,
            })
        );
    });
};